/* eslint-disable react/jsx-no-useless-fragment */

/*
 * Project: forca
 * File Created: Tuesday, 30th November 2021 1:49:31 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import SectionHeading from '@Components/sectionHeading';
import Image from '@Components/image';
import VideoQuoteBlockComponent from '@Components/videoQuoteBlock';

import { ArticleProps } from './article.definition';

export const Article = (props: ArticleProps) => {
	const {
		title,
		pageLink,
		image,
		thumbnail,
		video,
		videoId: id,
		MarketingCookiesDisabledText,
		MarketingCookiesVideoInformation,
		type,
		showDate = false,
		createdDate
	} = props;

	const formatDate = (date: any) => {
		const options: any = { month: 'long', day: 'numeric' };
		return new Date(date).toLocaleDateString('da-DK', options);
	};

	const renderHeadline = () => (
		<>
			{ type !== 'listed' ? (
				<>
					{ showDate && createdDate ? (
						<div className="mt-5">
							<span className="DitPKA-Article__Date">
								{ formatDate(createdDate) }
							</span>
							<SectionHeading headline={ title } alignLeft lessBottomMargin removeTopMargin headlineSize={ type === 'featured' ? 'small' : '' } />
						</div>

					) : (
						<SectionHeading headline={ title } alignLeft lessBottomMargin headlineSize={ type === 'featured' ? 'small' : '' } />
					) }
				</>
			) : (
				<h4 className="DitPKA-Article__Title">
					{ title }
					{ showDate && createdDate && (
						<span className="DitPKA-Article__Date">
							{ formatDate(createdDate) }
						</span>
					) }
				</h4>
			) }
		</>
	);

	const renderContent = () => (
		<>
			{ !video ? renderHeadline() : <a href={ pageLink } title={ title }>{ renderHeadline() }</a> }

			{ type !== 'listed' && (
				<>
					{ video && (
						<div
							className="base-band"
							data-debuginfo={ video }
							data-cookieinformation={ MarketingCookiesVideoInformation }
						>
							<VideoQuoteBlockComponent epiVideoUrl={ video } Headline="" MarketingCookiesDisabledText={ MarketingCookiesDisabledText } Baggrundsfarve="#000" id={ id } />
						</div>
					) }

					{ (!video && image) && (
						<Image src={ image } title={ title } alt={ title } ratio="16x9" />
					) }
				</>
			) }

			{ type === 'listed' && (
				<div className="DitPKA-Article__ImageWrapper">
					<Image src={ thumbnail } title={ title } alt={ title } ratio="16x9" />
				</div>
			) }
		</>
	);

	if (video) {
		return (
			<div className={ `DitPKA-Article DitPKA-Article--${ type }` }>
				{ renderContent() }
			</div>
		);
	}

	return (
		<a className={ `DitPKA-Article DitPKA-Article--${ type }` } href={ pageLink } title={ title }>
			{ renderContent() }
		</a>
	);
};

export default Article;